export const MOSCOW_TIME_ZONE = "Europe/Moscow";

const moscowHourFormatter = new Intl.DateTimeFormat("en-GB", {
  timeZone: MOSCOW_TIME_ZONE,
  hour: "2-digit",
  hour12: false,
});

type DateLike = string | number | Date | null | undefined;

function parseDate(value: DateLike): Date | null {
  if (value == null || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function currentMoscowHour(): number {
  return Number(moscowHourFormatter.format(new Date()));
}

export function formatMoscowDate(
  value: DateLike,
  options: Intl.DateTimeFormatOptions = {},
): string {
  const d = parseDate(value);
  if (!d) return "";
  return d.toLocaleDateString("ru-RU", {
    timeZone: MOSCOW_TIME_ZONE,
    ...options,
  });
}

export function formatMoscowDateTime(
  value: DateLike,
  options: Intl.DateTimeFormatOptions = {},
): string {
  const d = parseDate(value);
  if (!d) return "";
  return d.toLocaleString("ru-RU", {
    timeZone: MOSCOW_TIME_ZONE,
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  });
}

export function moscowDateToUtcIso(value: string): string | undefined {
  if (!value) return undefined;
  return new Date(`${value}T00:00:00+03:00`).toISOString();
}

export function moscowDateTimeToUtcIso(value: string): string | null {
  if (!value) return null;
  const withSeconds = value.length === 16 ? `${value}:00` : value;
  return new Date(`${withSeconds}+03:00`).toISOString();
}
